export class NetworkModel {
    constructor(data) {
        this.id = data.id;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.networkId = data.networkId;
        this.networkName = data.networkName;
        this.carrier = data.carrier;
        this.entityId = data.entityId;
        this.marketType = data.marketType;
        this.status = data.status;
    }
}